import { snackbarAction } from '../redux/actions/utilityAction';

export const throwError = (error) =>
    snackbarAction({
        open: true,
        type: 'error',
        message:
            error.response?.data?.message || error.response?.data?.description || 'Internal Error!',
    });
